/* eslint-disable */
/**
 * `land/market/*` — redesigned marketplace / shop pages (shop sidebar, character / gacha /
 * ECS pack / auction / resources-trend tabs). Mirrors the blob URLs referenced in
 * `pages/shop-page.tsx` and `components/Market/*`. Keep filenames in sync with those modules.
 */
const M = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/market'

/** Deduplicated absolute URLs for `VERCEL_BLOB_PRELOAD_PRIORITIZED` (not assetWarmup). */
export const MARKET_NEW_BLOB_PRELOAD_URLS: readonly string[] = [
  // Shop shell (`shop-page.tsx`) + sidebar (`ShopSidebar.tsx`)
  `${M}/bg.png`,
  `${M}/left.webp`,
  `${M}/right.webp`,
  `${M}/title-bg.webp`,
  `${M}/tab-active.webp`,
  `${M}/tab-inactive.webp`,
  `${M}/icon-characters.webp`,
  `${M}/icon-gacha.webp`,
  `${M}/icon-ecs-pack.webp`,
  `${M}/icon-marketplace.webp`,
  `${M}/icon-auction.webp`,
  // Character shop category tabs (`ShopCharacterCategoryTabs.tsx`)
  `${M}/character-page/change-type-btn.webp`,
  `${M}/character-page/change-type-btn-active.webp`,
  // Weapon tab (`WeaponTab.jsx`)
  `${M}/gacha-page/weapon-center.webp`,
  `${M}/gacha-page/weapon-1.webp`,
  `${M}/gacha-page/weapon-2.webp`,
  `${M}/gacha-page/decorator-left.webp`,
  `${M}/gacha-page/decorator-right.webp`,
  `${M}/gacha-page/gacha-purchase-btn.webp`,
  // ECS pack tab (`ECSPackTab.tsx`) + auction header (`AuctionTab.jsx`)
  `${M}/pack-page/badge-bg.webp`,
  `${M}/pack-page/pack-card.webp`,
  `${M}/pack-page/purchase-btn.webp`,
  `${M}/pack-page/tag-icon.webp`,
  `${M}/pack-page/dollar-icon.webp`,
  `${M}/pack-page/popular-badge.webp`,
  `${M}/pack-page/decorator-left.webp`,
  `${M}/pack-page/decorator-right.webp`,
  `${M}/pack-page/pack-1.png`,
  `${M}/pack-page/pack-2.png`,
  `${M}/pack-page/pack-3.png`,
  `${M}/pack-page/pack-4.png`,
  `${M}/pack-page/pack-5.png`,
  // Resources trend / trade tab (`ResourcesTrendTab.jsx`)
  `${M}/trade-page/slider-bg-1.webp`,
  `${M}/trade-page/slider-pointer.webp`,
  `${M}/trade-page/total-price-bg.webp`,
  `${M}/trade-page/panel-frame.webp`,
  `${M}/trade-page/trade-btn.webp`,
]
